import Icon from '../components/Icon.vue'

Icon.register({"box-open":{"width":640,"height":512,"paths":[{"d":"M53.2 41L1.7 143.8C-2.9 153 2 164 11.8 166.8L209.7 223.3C216.8 225.3 224.4 222.3 228.2 216L320 64 69.8 32.1C62.9 31.3 56.3 34.8 53.2 41zM638.3 143.8L586.8 41C583.7 34.8 577 31.2 570.1 32.1L320 64 411.7 216.1C415.5 222.4 423.1 225.4 430.2 223.4L628.1 166.9C638 164 642.8 153 638.3 143.8zM425.7 256C408.8 256 392.9 247 384.3 232.6L320 126 255.8 232.6C247.1 247.1 231.2 256.1 214.3 256.1 209.8 256.1 205.3 255.5 201 254.2L64 215V393C64 407.7 74 420.5 88.2 424L304.4 478.1C314.6 480.6 325.3 480.6 335.4 478.1L551.8 424C566 420.4 576 407.6 576 393V215L439 254.1C434.7 255.4 430.2 256 425.7 256z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/box-open.js
// module id = w+02
// module chunks = 0